export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/main.worker.175812d1.worker.js");
}
